<script setup lang="ts">
const emit = defineEmits(["close"]);
</script>
<template>
  <BaseLayoutModal width="medium" @close="$emit('close')">
    <template #header>
      {{ $t("main.keysSettings.connectSocialAccounts") }}
    </template>
    <template #content>
      <Transition mode="out-in">
        <div>
          <div class="flex flex-col items-center gap-3 max-w-sm mx-auto mb-8">
            <BaseIcon
              :name="'checkmark_green'"
              class="text-success-300 mt-7 mb-5 mx-auto w-20 h-20" />
            <p
              class="text-neutral-200 font-bold text-xl text-center"
              data-test="wallet-created-successfully">
              {{ $t("main.keysSettings.accountLinked") }}
            </p>
            <p class="text-neutral-300 text-center">
              {{ $t("main.keysSettings.accountSuccessfullyLinked") }}
            </p>
          </div>
          <div class="mt-5 mb-2 sm:mt-6 flex">
            <BaseButtonSubmit
              :text="$t('main.modalWalletCreationSuccess.close')"
              data-test="button-close-modal-wallet-creation-success"
              size="long"
              class="mx-auto"
              @click="emit('close')" />
          </div>
        </div>
      </Transition>
    </template>
  </BaseLayoutModal>
</template>
